import { ArrowRight } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";
import { scrollToId } from "@/lib/scroll";

const CAKES = [
  { size: '4" Round Cake', price: "$50" },
  { size: '6" Round Cake', price: "$80" },
  { size: '8" Round Cake', price: "$120" },
];

const DESSERTS = [
  {
    name: "Cupcakes",
    price: "$30\u2013$35 per dozen",
    copy: "Perfect for parties, showers, celebrations, and dessert tables.",
    src: "/images/dessert-cupcakes.jpg",
    testid: "dessert-card-cupcakes",
  },
  {
    name: "Macarons",
    price: "$25\u2013$30 per dozen",
    copy: "Beautiful handcrafted macarons available to complement your celebration.",
    src: "/images/dessert-macarons.jpg",
    testid: "dessert-card-macarons",
  },
];

const Pricing = () => (
  <section id="pricing" className="scroll-mt-24 py-24 sm:py-32" data-testid="pricing-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Chapter num="03" label="Sizes & Starting Prices" />
      </Reveal>
      <div className="mt-6 grid grid-cols-1 gap-16 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal delay={0.1}>
            <h2 className="font-display text-4xl font-light leading-tight tracking-tight text-[#2D2422] sm:text-5xl">
              Custom cakes, priced around your design
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-[#5C4B47]">
              Listed prices are starting prices. Final pricing depends on design complexity,
              decorations, flavors, and customization.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-6 lg:col-start-7">
          {CAKES.map((c, i) => (
            <Reveal key={c.size} delay={0.1 + i * 0.08}>
              <div
                className="flex items-baseline justify-between border-b border-[#E8D8D3] py-6"
                data-testid={`price-row-${c.size.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
              >
                <span className="font-display text-2xl font-light text-[#2D2422] sm:text-3xl">{c.size}</span>
                <span className="text-right">
                  <span className="font-accent block text-[11px] font-semibold uppercase tracking-[0.22em] text-[#8A7975]">
                    Starting at
                  </span>
                  <span className="font-display text-2xl italic text-[#C48B71] sm:text-3xl">{c.price}</span>
                </span>
              </div>
            </Reveal>
          ))}
          <Reveal delay={0.4}>
            <p className="mt-6 font-display text-lg italic text-[#8A7975]" data-testid="pricing-note">
              All cake pricing is customized based on the final design.
            </p>
          </Reveal>
        </div>
      </div>

      <div className="mt-24 grid grid-cols-1 gap-8 md:grid-cols-2" data-testid="desserts-section">
        {DESSERTS.map((d, i) => (
          <Reveal key={d.name} delay={i * 0.12}>
            <div
              className="group overflow-hidden rounded-3xl border border-[#E8D8D3]/70 bg-white"
              data-testid={d.testid}
            >
              <div className="overflow-hidden">
                <img
                  src={d.src}
                  alt={`${d.name} by Bella Bells Cakes, San Diego`}
                  loading="lazy"
                  className="aspect-[16/10] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
              </div>
              <div className="p-8">
                <div className="flex items-baseline justify-between gap-4">
                  <h3 className="font-display text-3xl font-light text-[#2D2422]">{d.name}</h3>
                  <span className="font-accent text-sm font-semibold text-[#C48B71]">{d.price}</span>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-[#5C4B47]">{d.copy}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2} className="mt-12 text-center">
        <button onClick={() => scrollToId("#inquiry")} className="btn-outline" data-testid="desserts-request-btn">
          Request Desserts <ArrowRight size={16} strokeWidth={1.5} />
        </button>
      </Reveal>
    </div>
  </section>
);

export default Pricing;
